import { useRef } from "react";

// ponytail: horizontal swipe detection for reel videos and the product page.
// A 50px minimum horizontal travel with horizontal dominance keeps gestures
// from fighting the vertical reels swiper (up/down slide navigation).
const SWIPE_THRESHOLD = 50;

const useSwipe = (direction, onSwipe) => {
  const startRef = useRef(null);

  const onTouchStart = (e) => {
    const touch = e.touches[0];
    if (!touch) return;
    startRef.current = { x: touch.clientX, y: touch.clientY };
  };

  const onTouchEnd = (e) => {
    const start = startRef.current;
    startRef.current = null;
    if (!start || !onSwipe) return;
    const touch = e.changedTouches[0];
    if (!touch) return;
    const dx = touch.clientX - start.x;
    const dy = touch.clientY - start.y;
    if (direction === "right" && dx > SWIPE_THRESHOLD && dx > Math.abs(dy)) onSwipe();
    else if (direction === "left" && dx < -SWIPE_THRESHOLD && -dx > Math.abs(dy)) onSwipe();
  };

  return { onTouchStart, onTouchEnd };
};

export const useSwipeRight = (onSwipeRight) => useSwipe("right", onSwipeRight);
export const useSwipeLeft = (onSwipeLeft) => useSwipe("left", onSwipeLeft);

export default useSwipeRight;